/*
 * The Tenants tab of the Person Detail modal (audit Phase 3.3). Replaces
 * wwwroot/js/PersonTenant/Tab.js and _namespace.js on the Phase 3.1 core.
 * No jQuery.
 *
 * Read plus remove only. A Person is added to a Tenant from the Tenant's own
 * Members tab, because that is the surface that knows the Tenant's Domain --
 * the cardinality rule is one Tenant per Person per Domain, and this tab can
 * only see the Person.
 */
import { ajaxJson, ajaxSwap, failToast } from '../core/ajax';
import { confirm } from '../core/modal';
import { toast } from '../core/toast';

export const Tab = {
    Remove(personId: number | string, tenantId: number | string): void {
        void confirm({
            title: 'Remove from Tenant',
            message: 'Remove this Person from the Tenant? Their Domain membership and other claims are unaffected.',
            confirmText: 'Remove',
            variant: 'danger',
            onConfirm: () => {
                void ajaxJson({
                    url: `PersonTenant/Person/${personId}/Tenant/${tenantId}`,
                    method: 'DELETE',
                    alertInto: `PersonTenantsMessageContainer_${personId}`,
                    errorTitle: 'Failed to remove from Tenant',
                    onSuccess: () => {
                        toast('success', 'Removed from Tenant');
                        void Tab.Reload(personId);
                    },
                    onFailure: failToast('Failed to remove from Tenant'),
                });
            },
        });
    },

    Reload(personId: number | string): Promise<void> {
        return ajaxSwap({
            container: 'PersonTenantsTab',
            url: `PersonTenant/Person/${personId}`,
            alertTitle: 'Failed to reload Tenant memberships',
        });
    },
};
